/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type LastInteractionFilterConfigColumn =
  (typeof LastInteractionFilterConfigColumn)[keyof typeof LastInteractionFilterConfigColumn];

export const LastInteractionFilterConfigColumn = {
  last_interaction: 'last_interaction',
} as const;
